<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import {mapActions} from 'vuex'
import User from "@/models/User";

export default {
  name: 'application',
  created() {
    if(this.$router.history.pending) {
      const pd = this.$router.history.pending
      if (pd.path === '/public/daily') {
        return
      }
    }
    if (this.$route.query && this.$route.query.public) {
      return
    }
    this.fetchCurrentUser().then(resp => {
      const user = new User(resp)
      if (user.isLogined()) {
        if (this.$route.path.indexOf("/main") < 0) {
          this.$router.push('/main')
        }
      } else {
        this.$router.push('/login')
      }
    })
  },
  methods: {
    ...mapActions({
      'fetchCurrentUser': 'fetchCurrentUser'
    })
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
